import React from "react";

import Modal from "~/ui/Modal";
import { __globalModalContext } from "~/ui/modals";

import MeetingModalThroughNoteId from "./MeetingModalThroughNoteId";
import MeetingModalThroughRecordingId from "./MeetingModalThroughRecordingId";

import styles from "./MeetingModal.module.css";

export type MeetingModalCommonProps = {
	initialVideoTimestamp?: number;
	timestampStart?: number | null;
	timestampEnd?: number | null;
};

/**
 * Opens the Meeting Modal given a Recording ID or a Note ID. Be sure to check if this content should be paywalled
 * before calling.
 */
export default function openMeetingModal({
	noteId,
	recordingId,
	timestamp,
	timestampEnd,
}: {
	noteId?: string;
	recordingId?: string;
	timestamp?: number;
	timestampEnd?: number | null;
}) {
	if (!noteId && !recordingId) {
		throw new Error("Either noteId or recordingId must be provided");
	}

	__globalModalContext?.open<null>(
		({ close }) => {
			return (
				<Modal
					key="meeting-modal"
					onClose={close}
					className={styles.meetingModal}
					overlayClassName={styles.overlayReducedPadding}
				>
					{noteId ? (
						<MeetingModalThroughNoteId
							close={close}
							noteNodeId={noteId}
							initialMeetingRecordingId={recordingId}
							initialVideoTimestamp={timestamp}
							timestampStart={timestamp}
							timestampEnd={timestampEnd}
						/>
					) : (
						recordingId && (
							<MeetingModalThroughRecordingId
								close={close}
								recordingId={recordingId}
								initialVideoTimestamp={timestamp}
								timestampStart={timestamp}
								timestampEnd={timestampEnd}
							/>
						)
					)}
				</Modal>
			);
		},
		{ exclusiveId: "meeting-modal", persistOnNavigation: true },
	);
}
